import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool, customPaging } from "@/mixins/index";
import { partnerList } from "@/api/dataAll/dataAll";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import { template } from 'lodash';
export default {
  name: "partnerListDetail",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool, customPaging],
  data: function data() {
    return {
      more: true,
      value2: [],
      paramsData: {
        time: '',
        page_size: 10,
        page: 1
      },
      // PrimitiveserverLists: [],
      // serverLists: [],
      tableData: [],
      // Dynamic: [],
      // isServer: false,
      serverList: [],
      total: 0,
      exportdataloading: false
    };
  },
  created: function created() {
    this.getsearchDate();
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.paramsData.time = date;
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    sizeChange: function sizeChange(e) {
      this.paramsData.page_size = e;
      this.searchClick(1);
    },
    searchClick: function searchClick(e) {
      var _this2 = this;

      this.paramsData.page = e;
      var data = JSON.parse(JSON.stringify(this.paramsData));
      this.reqLoading = true;
      partnerList(_objectSpread(_objectSpread({}, this.searchData), data)).then(function (res) {
        if (res.code == 200) {
          var tableNewdata = res.data;
          var list = _this2.rawData.game_mark.indexOf('royalpirates') > -1 ? _this2.serverList : _this2.serverListYJ;
          tableNewdata.forEach(function (item) {
            var foundData = list.find(function (b) {
              return b.serverID == item.server_id;
            });
            item.server_name = foundData ? foundData.serverName : '/';
          });
          _this2.tableData = tableNewdata;
          _this2.total = res.total ? res.total - 0 : 0;

          _this2.$nextTick(function () {
            _this2.getTableRight();
          });
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var _this3 = this;

      this.exportdataloading = true;
      var data = JSON.parse(JSON.stringify(this.paramsData));
      partnerList(_objectSpread(_objectSpread(_objectSpread({}, this.searchData), data), {}, {
        page_size: -1
      })).then(function (res) {
        if (res.code == 200) {
          var columns = [{
            label: _this3.$t('date'),
            prop: 'time'
          }, {
            label: _this3.$t('adChannel'),
            prop: 'ad_channel'
          }, {
            label: _this3.$t('adPlacement'),
            prop: 'ad_placement'
          }, {
            label: _this3.$t('game'),
            prop: 'game'
          }, {
            label: _this3.$t('platform'),
            prop: 'platform'
          }, {
            label: _this3.$t('channel'),
            prop: 'channel'
          }, {
            label: _this3.$t('pkg'),
            prop: 'pkg'
          }, {
            label: _this3.$t('roleId'),
            prop: 'role_id'
          }, {
            label: _this3.$t('roleName'),
            prop: 'role_name'
          }, {
            label: _this3.$t('serverName'),
            prop: 'server_name'
          }, {
            label: _this3.$t('userId'),
            prop: 'user_id'
          }, {
            label: _this3.$t('partnerFightPower'),
            prop: 'fight_power'
          }, {
            label: _this3.$t('roleFightPower'),
            prop: 'fighting'
          }, {
            label: _this3.$t('partnerId'),
            prop: 'hero_id'
          }, {
            label: _this3.$t('partnerLevel'),
            prop: 'level'
          }, {
            label: _this3.$t('partnerStar'),
            prop: 'star'
          }];
          var tableNewdata = res.data;
          var list = _this3.rawData.game_mark.indexOf('royalpirates') > -1 ? _this3.serverList : _this3.serverListYJ;
          tableNewdata.forEach(function (item) {
            var foundData = list.find(function (b) {
              return b.serverID == item.server_id;
            });
            item.server_name = foundData ? foundData.serverName : '/';
          });

          _this3.$export.excel({
            columns: columns,
            data: tableNewdata,
            title: _this3.$route.meta.title
          });
        }
      }).finally(function () {
        _this3.exportdataloading = false;
      });
    }
  }
};